import { Button, Container, Tab, Tabs } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";

import { useOrgConfig } from "~/providers/OrgConfigProvider";
import CreateErrandTypeDialog from "./CreateErrandTypeDialog";
import ErrandType from "./ErrandType";

type Props = {
  id?: number;
};

const TabErrands = ({ id }: Props) => {
  const { errandTypes } = useOrgConfig();
  const navigate = useNavigate();
  const [createOpen, setCreateOpen] = useState(false);

  if (!id) {
    const firstId = Object.values(errandTypes)[0]?.id;
    if (firstId) {
      return <Navigate to={`/operate-config/errands/${firstId}`} replace />;
    }
  }

  return (
    <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 4, lg: 3, xl: 2 }}>
          <Tabs
            value={id ?? false}
            onChange={(_, newValue) => navigate(`/operate-config/errands/${newValue}`)}
            orientation="vertical"
            variant="scrollable"
            sx={{ maxHeight: 400, ".MuiTabScrollButton-root": { display: "none" } }}
            visibleScrollbar
          >
            {Object.values(errandTypes).map(errand => (
              errand ? <Tab key={errand.id} label={errand.name} value={errand.id} /> : null
            ))}
          </Tabs>
          <Button variant="contained" fullWidth sx={{ mt: 2 }} onClick={() => setCreateOpen(true)}>
            Create Errand
          </Button>
          <CreateErrandTypeDialog open={createOpen} onClose={() => setCreateOpen(false)} />
        </Grid>
        <Grid size={{ xs: 12, md: 8, lg: 9, xl: 10 }}>
          {id && errandTypes[id] ? <ErrandType key={id} errandTypeId={id} /> : null}
        </Grid>
      </Grid>
    </Container>
  );
};

export default TabErrands;
